import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mapper-emit-rule"
  }, [_c('div', {
    staticClass: "mapper-emit-rule__header"
  }, [_c('strong', {
    staticClass: "mapper-emit-rule__title"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Bridges.mapperBuilder.emit.rule')) + " " + _vm._s(_vm.index + 1))]), _c(VSpacer), _c(VBtn, {
    attrs: {
      "disabled": _vm.disabled || _vm.index === 0,
      "icon": "",
      "small": "",
      "title": _vm.$i18n_t('Bridges.mapperBuilder.emit.moveUp'),
      "data-test": `mapper-emit-${_vm.index}-up`
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('move', -1);
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "14"
    }
  }, [_vm._v("fal fa-arrow-up")])], 1), _c(VBtn, {
    attrs: {
      "disabled": _vm.disabled || _vm.index === _vm.count - 1,
      "icon": "",
      "small": "",
      "title": _vm.$i18n_t('Bridges.mapperBuilder.emit.moveDown'),
      "data-test": `mapper-emit-${_vm.index}-down`
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('move', 1);
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "14"
    }
  }, [_vm._v("fal fa-arrow-down")])], 1), _c(VBtn, {
    attrs: {
      "disabled": _vm.disabled,
      "icon": "",
      "small": "",
      "title": _vm.$i18n_t('Bridges.mapperBuilder.emit.remove'),
      "data-test": `mapper-emit-${_vm.index}-remove`
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('remove');
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "14"
    }
  }, [_vm._v("fal fa-trash-alt")])], 1)], 1), _c(VTextField, {
    attrs: {
      "value": _vm.value.foreach,
      "label": _vm.$i18n_t('Bridges.mapperBuilder.emit.foreach'),
      "hint": _vm.$i18n_t('Bridges.mapperBuilder.emit.foreachHint'),
      "disabled": _vm.disabled,
      "clearable": "",
      "dense": "",
      "outlined": "",
      "persistent-hint": "",
      "data-test": `mapper-emit-${_vm.index}-foreach`
    },
    on: {
      "input": function ($event) {
        return _vm.setForeach($event);
      }
    }
  }), !_vm.activeOutput ? _c(VAlert, {
    staticClass: "mapper-emit-rule__alert",
    attrs: {
      "dense": "",
      "text": "",
      "type": "info"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.emit.missingOutput')) + "\n    "), _c(VBtn, {
    attrs: {
      "disabled": _vm.disabled,
      "small": "",
      "text": "",
      "data-test": `mapper-emit-${_vm.index}-create-output`
    },
    on: {
      "click": function ($event) {
        return _vm.createOutput();
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.emit.createOutput')) + "\n    ")])], 1) : _vm._e(), _vm.hasInactiveOutput ? _c(VAlert, {
    staticClass: "mapper-emit-rule__alert",
    attrs: {
      "dense": "",
      "text": "",
      "type": "warning"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.emit.inactiveOutputKept')) + "\n  ")]) : _vm._e(), _vm.activeOutput && _vm.shape === 'direct' ? [_c('div', {
    staticClass: "mapper-emit-rule__row"
  }, [_c('mapper-value-spec-chip', {
    attrs: {
      "value": _vm.value.direct.dtwinId,
      "label": _vm.$i18n_t('Bridges.mapperBuilder.emit.dtwinId'),
      "captures": _vm.captures,
      "lookup-tables": _vm.lookupTables,
      "disabled": _vm.disabled,
      "data-test": `mapper-emit-${_vm.index}-dtwin-id`
    },
    on: {
      "input": function ($event) {
        return _vm.setOn(_vm.value.direct, 'dtwinId', $event);
      },
      "change": function ($event) {
        return _vm.$emit('change');
      }
    }
  }), _c('mapper-value-spec-chip', {
    attrs: {
      "value": _vm.value.direct.deviceId,
      "label": _vm.$i18n_t('Bridges.mapperBuilder.emit.deviceId'),
      "captures": _vm.captures,
      "lookup-tables": _vm.lookupTables,
      "disabled": _vm.disabled,
      "optional": "",
      "data-test": `mapper-emit-${_vm.index}-device-id`
    },
    on: {
      "input": function ($event) {
        return _vm.setOn(_vm.value.direct, 'deviceId', $event);
      },
      "change": function ($event) {
        return _vm.$emit('change');
      }
    }
  })], 1), _c('div', {
    staticClass: "mapper-emit-rule__subtitle text--secondary"
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.emit.stateUpdates')) + "\n    ")]), _c('table', {
    staticClass: "mapper-emit-rule__table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$i18n_t('Bridges.mapperBuilder.emit.stateId')))]), _c('th', [_vm._v(_vm._s(_vm.$i18n_t('Bridges.mapperBuilder.emit.value')))]), _c('th', [_vm._v(_vm._s(_vm.$i18n_t('Bridges.mapperBuilder.emit.time')))]), _c('th', [_vm._v(_vm._s(_vm.$i18n_t('Bridges.mapperBuilder.emit.valueType')))]), _c('th')])]), _c('tbody', _vm._l(_vm.value.direct.updates, function (update, updateIndex) {
    return _c('tr', {
      key: update.uiKey
    }, [_c('td', [_c('mapper-value-spec-chip', {
      attrs: {
        "value": update.stateId,
        "default-kind": "literal",
        "captures": _vm.captures,
        "lookup-tables": _vm.lookupTables,
        "disabled": _vm.disabled,
        "label": _vm.$i18n_t('Bridges.mapperBuilder.emit.stateId'),
        "show-label": false,
        "data-test": `mapper-emit-${_vm.index}-update-${updateIndex}-state-id`
      },
      on: {
        "input": function ($event) {
          return _vm.setOn(update, 'stateId', $event);
        },
        "change": function ($event) {
          return _vm.$emit('change');
        }
      }
    })], 1), _c('td', [_c('mapper-value-spec-chip', {
      attrs: {
        "value": update.value,
        "captures": _vm.captures,
        "lookup-tables": _vm.lookupTables,
        "disabled": _vm.disabled,
        "label": _vm.$i18n_t('Bridges.mapperBuilder.emit.value'),
        "show-label": false,
        "data-test": `mapper-emit-${_vm.index}-update-${updateIndex}-value`
      },
      on: {
        "input": function ($event) {
          return _vm.setOn(update, 'value', $event);
        },
        "change": function ($event) {
          return _vm.$emit('change');
        }
      }
    })], 1), _c('td', [_c('mapper-value-spec-chip', {
      attrs: {
        "value": update.time,
        "captures": _vm.captures,
        "lookup-tables": _vm.lookupTables,
        "disabled": _vm.disabled,
        "optional": "",
        "label": _vm.$i18n_t('Bridges.mapperBuilder.emit.time'),
        "show-label": false,
        "data-test": `mapper-emit-${_vm.index}-update-${updateIndex}-time`
      },
      on: {
        "input": function ($event) {
          return _vm.setOn(update, 'time', $event);
        },
        "change": function ($event) {
          return _vm.$emit('change');
        }
      }
    })], 1), _c('td', [_c('mapper-value-spec-chip', {
      attrs: {
        "value": update.valueType,
        "default-kind": "literal",
        "captures": _vm.captures,
        "lookup-tables": _vm.lookupTables,
        "disabled": _vm.disabled,
        "optional": "",
        "label": _vm.$i18n_t('Bridges.mapperBuilder.emit.valueType'),
        "show-label": false,
        "data-test": `mapper-emit-${_vm.index}-update-${updateIndex}-value-type`
      },
      on: {
        "input": function ($event) {
          return _vm.setOn(update, 'valueType', $event);
        },
        "change": function ($event) {
          return _vm.$emit('change');
        }
      }
    })], 1), _c('td', {
      staticClass: "mapper-emit-rule__table-actions"
    }, [_c(VBtn, {
      attrs: {
        "disabled": _vm.disabled,
        "icon": "",
        "small": "",
        "title": _vm.$i18n_t('Bridges.mapperBuilder.emit.removeUpdate'),
        "data-test": `mapper-emit-${_vm.index}-update-${updateIndex}-remove`
      },
      on: {
        "click": function ($event) {
          return _vm.removeUpdate(updateIndex);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        "size": "14"
      }
    }, [_vm._v("fal fa-trash-alt")])], 1)], 1)]);
  }), 0)]), _c(VBtn, {
    attrs: {
      "disabled": _vm.disabled,
      "small": "",
      "text": "",
      "data-test": `mapper-emit-${_vm.index}-add-update`
    },
    on: {
      "click": function ($event) {
        return _vm.addUpdate();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "left": "",
      "size": "12"
    }
  }, [_vm._v("fal fa-plus")]), _vm._v("\n      " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.emit.addUpdate')) + "\n    ")], 1)] : _vm._e(), _vm.activeOutput && _vm.shape === 'ddr' ? [_c('div', {
    staticClass: "mapper-emit-rule__row"
  }, [_c('mapper-value-spec-chip', {
    attrs: {
      "value": _vm.value.ddr.variable,
      "default-kind": "literal",
      "label": _vm.$i18n_t('Bridges.mapperBuilder.emit.variable'),
      "captures": _vm.captures,
      "lookup-tables": _vm.lookupTables,
      "disabled": _vm.disabled,
      "data-test": `mapper-emit-${_vm.index}-variable`
    },
    on: {
      "input": function ($event) {
        return _vm.setOn(_vm.value.ddr, 'variable', $event);
      },
      "change": function ($event) {
        return _vm.$emit('change');
      }
    }
  }), _c('mapper-value-spec-chip', {
    attrs: {
      "value": _vm.value.ddr.deviceId,
      "label": _vm.$i18n_t('Bridges.mapperBuilder.emit.deviceId'),
      "captures": _vm.captures,
      "lookup-tables": _vm.lookupTables,
      "disabled": _vm.disabled,
      "optional": "",
      "data-test": `mapper-emit-${_vm.index}-device-id`
    },
    on: {
      "input": function ($event) {
        return _vm.setOn(_vm.value.ddr, 'deviceId', $event);
      },
      "change": function ($event) {
        return _vm.$emit('change');
      }
    }
  })], 1), _c('div', {
    staticClass: "mapper-emit-rule__subtitle text--secondary"
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.emit.routing')) + "\n    ")]), _c(VBtnToggle, {
    staticClass: "mb-2",
    attrs: {
      "value": _vm.value.ddr.routingSource,
      "dense": "",
      "mandatory": ""
    },
    on: {
      "change": function ($event) {
        return _vm.setRoutingSource($event);
      }
    }
  }, _vm._l(_vm.routingSources, function (source) {
    return _c(VBtn, {
      key: source,
      attrs: {
        "value": source,
        "disabled": _vm.disabled,
        "small": "",
        "data-test": `mapper-emit-${_vm.index}-routing-${source}`
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t(`Bridges.mapperBuilder.emit.routingSources.${source}`)) + "\n      ")]);
  }), 1), _vm.value.ddr.routingSource === 'fields' ? [_vm._l(_vm.value.ddr.routingRows, function (row, rowIndex) {
    return _c('div', {
      key: row.uiKey,
      staticClass: "mapper-emit-rule__key-row"
    }, [_c(VTextField, {
      attrs: {
        "value": row.name,
        "label": _vm.$i18n_t('Bridges.mapperBuilder.emit.routingField'),
        "disabled": _vm.disabled,
        "dense": "",
        "hide-details": "",
        "outlined": "",
        "data-test": `mapper-emit-${_vm.index}-routing-${rowIndex}-name`
      },
      on: {
        "input": function ($event) {
          return _vm.setRoutingName(row, $event);
        }
      }
    }), _c('mapper-value-spec-chip', {
      attrs: {
        "value": row.spec,
        "captures": _vm.captures,
        "lookup-tables": _vm.lookupTables,
        "disabled": _vm.disabled,
        "label": _vm.$i18n_t('Bridges.mapperBuilder.emit.routingValue'),
        "data-test": `mapper-emit-${_vm.index}-routing-${rowIndex}-value`
      },
      on: {
        "input": function ($event) {
          return _vm.setOn(row, 'spec', $event);
        },
        "change": function ($event) {
          return _vm.$emit('change');
        }
      }
    }), _c(VBtn, {
      attrs: {
        "disabled": _vm.disabled,
        "icon": "",
        "small": "",
        "title": _vm.$i18n_t('Bridges.mapperBuilder.emit.removeRoutingField'),
        "data-test": `mapper-emit-${_vm.index}-routing-${rowIndex}-remove`
      },
      on: {
        "click": function ($event) {
          return _vm.removeRoutingRow(rowIndex);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        "size": "14"
      }
    }, [_vm._v("fal fa-trash-alt")])], 1)], 1);
  }), _c(VBtn, {
    attrs: {
      "disabled": _vm.disabled,
      "small": "",
      "text": "",
      "data-test": `mapper-emit-${_vm.index}-add-routing`
    },
    on: {
      "click": function ($event) {
        return _vm.addRoutingRow();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "left": "",
      "size": "12"
    }
  }, [_vm._v("fal fa-plus")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.emit.addRoutingField')) + "\n      ")], 1)] : _c('mapper-value-spec-chip', {
    attrs: {
      "value": _vm.value.ddr.routingSpec,
      "captures": _vm.captures,
      "lookup-tables": _vm.lookupTables,
      "disabled": _vm.disabled,
      "label": _vm.$i18n_t('Bridges.mapperBuilder.emit.routingValue'),
      "data-test": `mapper-emit-${_vm.index}-routing-value`
    },
    on: {
      "input": function ($event) {
        return _vm.setOn(_vm.value.ddr, 'routingSpec', $event);
      },
      "change": function ($event) {
        return _vm.$emit('change');
      }
    }
  }), _c('div', {
    staticClass: "mapper-emit-rule__subtitle text--secondary"
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.emit.data')) + "\n    ")]), _c('div', {
    staticClass: "mapper-emit-rule__row"
  }, [_c('mapper-value-spec-chip', {
    attrs: {
      "value": _vm.value.ddr.data.value,
      "label": _vm.$i18n_t('Bridges.mapperBuilder.emit.value'),
      "captures": _vm.captures,
      "lookup-tables": _vm.lookupTables,
      "disabled": _vm.disabled,
      "data-test": `mapper-emit-${_vm.index}-data-value`
    },
    on: {
      "input": function ($event) {
        return _vm.setOn(_vm.value.ddr.data, 'value', $event);
      },
      "change": function ($event) {
        return _vm.$emit('change');
      }
    }
  }), _c('mapper-value-spec-chip', {
    attrs: {
      "value": _vm.value.ddr.data.time,
      "label": _vm.$i18n_t('Bridges.mapperBuilder.emit.time'),
      "captures": _vm.captures,
      "lookup-tables": _vm.lookupTables,
      "disabled": _vm.disabled,
      "optional": "",
      "data-test": `mapper-emit-${_vm.index}-data-time`
    },
    on: {
      "input": function ($event) {
        return _vm.setOn(_vm.value.ddr.data, 'time', $event);
      },
      "change": function ($event) {
        return _vm.$emit('change');
      }
    }
  }), _c('mapper-value-spec-chip', {
    attrs: {
      "value": _vm.value.ddr.data.valueType,
      "default-kind": "literal",
      "label": _vm.$i18n_t('Bridges.mapperBuilder.emit.valueType'),
      "captures": _vm.captures,
      "lookup-tables": _vm.lookupTables,
      "disabled": _vm.disabled,
      "optional": "",
      "data-test": `mapper-emit-${_vm.index}-data-value-type`
    },
    on: {
      "input": function ($event) {
        return _vm.setOn(_vm.value.ddr.data, 'valueType', $event);
      },
      "change": function ($event) {
        return _vm.$emit('change');
      }
    }
  })], 1)] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };